const e = {
  name: "Clipboard",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,6V5c0-2.8,2.2-5,5-5s5,2.2,5,5v1h6c1.7,0,3,1.3,3,3v28c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V9
			c0-1.7,1.3-3,3-3H9z M11,5v1h6V5c0-1.7-1.3-3-3-3S11,3.3,11,5z M8,8v2h12V8H8z M3,8C2.4,8,2,8.4,2,9v28c0,0.6,0.4,1,1,1h22
			c0.6,0,1-0.4,1-1V9c0-0.6-0.4-1-1-1h-3v4H6V8H3z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Clipboard
};
